import { FC } from 'react';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { IActionMenuProps } from './types';

const ActionMenu: FC<IActionMenuProps> = ({ data = [], placement, icon }) => {
  const onClick = (info: { key: string }) => {
    const item = data.find(({ title }) => info.key === `menu-item-${title}`);

    if (item?.link) {
      return;
    }

    item?.action?.();
  };

  return (
    <Dropdown
      menu={{
        items: data.map(({ title, link, danger, disabled }) => ({
          key: `menu-item-${title}`,
          label: link ? <Link to={link}>{title}</Link> : title,
          danger,
          disabled
        })),
        onClick
      }}
      placement={placement}
      trigger={['click']}
    >
      <Button type="text">{icon ? icon : <MoreOutlined />}</Button>
    </Dropdown>
  );
};

export default ActionMenu;
